import React from "react";

const Card = ( {data} ) => {
    return(
        
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 px-5 mt-10 justify-between">
            
            {
                data.card.map( (card, index ) => (

                    <div key={index} onClick={() => window.location.replace(card.url_source)} 
                            className="relative bg-cover flex flex-row flex-wrap p-10 bg-no-repeat
                            rounded-3xl group cursor-pointer" style={{ backgroundImage: `url('${card.bg}')` }}
                        >
                        <div className="absolute inset-0 opacity-40 group-hover:opacity-25 ease-linear transition-opacity duration-500 rounded-3xl" style={{ backgroundColor: card.bg_color }}></div>

                        <div className="flex flex-row items-end lg:justify-between justify-between sm:justify-normal sm:gap-20 lg:h-[425px] sm:h-[509px] h-[347px]  w-full relative z-10">
                            <div className="flex flex-col text-pretty gap-4 sm:w-[65%] lg:w-full">
                                <span className="md:text-[32px] text-[24px] sm:text-lg" style={{ color: card.desc_color }}>{card.desc}</span>
                                <span className="text-[12px]" style={{ color: card.date_color }}>{card.date}</span>
                            </div>
                            <img className="h-5" src={card.link_arrow} alt="" />
                        </div>
                    </div>

            )) 
        
        }

        </div>

    );
};

export default Card;